function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M66.857 48.857V63l-34.714 5.143-13.5-1.929m48.214-24.428v-7.072l-34.714 5.143-27-3.857v28.286l6.75.964M59.324 58l2.275-.337M49.063 59.52l6.223-1.02M32.143 68.143V39.857M10.286 42.429V45M10.286 50.143v6.429",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.304 37.31l-6.59-16.738L32.143 5.143H54l.75 2.179.75 2.178",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.714 20.572h21.858l1.839 4.644m5.519 13.932l-3.68-9.288",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.926 25.616l-2.076-5.044L42.268 5.143M29.572 20.572L54 5.143",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M58 32c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M64.062 32l.937 2.03",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M53 21.5l3.667 3.5 3.666-3.5L64 18",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgInDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default __webpack_public_path__ + "/img/in-deposit.svg";
export { SvgInDeposit as ReactComponent };